/* eslint-disable */
// import Swiper from "swiper/bundle";
//import Swiper from "swiper";

/* eslint-enable */

class Outstanding {
	
	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$outstanding = this.sectionsContainer.querySelector('.outstanding');
		
		if (!this.$outstanding)
			return;
		
		this.$outstandingElements = this.$outstanding.querySelectorAll('.anima');
	
		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
        gsap.set(this.$outstanding, { opacity: 0.0001});
        gsap.set(this.$outstandingElements, { yPercent: 20, opacity: 0.0001, onComplete: () => {
				this.initAnimate();
		} });
	}

	initAnimate() {
		this.animateoutstanding = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$outstanding,
				start: 'top 70%'
			},
			onComplete: () => {
				gsap.set(this.$outstandingElements, { clearProps: true });
			}
        });
    
        this.animateoutstanding.addLabel('step1');
        this.animateoutstanding.to(this.$outstanding, { opacity: 1, duration: 1 }, 'step1');
		this.animateoutstanding.to(this.$outstandingElements, { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}
export default Outstanding;
